import React, { useContext, useEffect, useState } from "react";

import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import { Label } from "../../../../../../stories/Label/Label";
import { Button } from "../../../../../../stories/Button/Button";

import { AppContext } from "../../../../../../context/context";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import
{
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  emptyMessage,
} from "../../../../../../utils/constants";
import { Operation, empType } from "../../../../../../utils/Enum.types";
import { getModifiedScrollHeight } from "../../../../../../utils/UtilFunctions";
import MessageModal from "../../../../../../customComponents/MessageModal";
import LoadingModal from "../../../../../pages/LoadingModal";
import { StyledDatagrid } from "../../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../../styles/Variables";
import
{
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import { ColumnVisibilityFor } from "../../../../../../utils/Enum.Datagrid";
import { payloadTypes } from "../../../../../../context/reducer";
import NoData from "../../../../../../images/NoData.svg";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import { Checkbox } from "@mui/material";
import { TableHeaderProps } from "../../../../../../utils/types";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
import { useLazyQuery, useMutation } from "@apollo/client";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import { GetSuppliers } from "../../supplier/queries/queries";
import
{
  AtsAcLdgrOrderField,
  LdgrQueryType,
} from "../../supplier/queries/types";
import Input from "../../../../../../stories/Input/Input";
import useLabels from "../../../../../../customHooks/useLabels";
import { selectedSupplierType } from "./AssociateEmps";
import
{
  EmpMasterEdge,
  EmpMasterOrderField,
  EmpQueryType,
  GetEmpResult,
  GetEmpVars,
} from "../../../users/queries/types";
import { GetEmp } from "../../../users/queries/queries";
import { AddEmpLdgrAssoicResult, AddEmpLdgrAssoicVar } from "./queries/types";
import { AddEmpLdgrAssoic } from "./queries/mutations";

interface Props
{
  selectedSupplier: selectedSupplierType;
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const AssignEmps = ( { selectedSupplier, setModalFlag }: Props ) =>
{
  const { Users } = useAssetTableJson();

  const { dispatch } = useContext( AppContext );
  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();

  const [ viewModal, setViewModal ] = useState( false );
  const [ selectedItems, setSelectedItems ] = useState<number[]>( [] );
  const [ message, setMessage ] = useState( emptyMessage );
  const [ rows, setRows ] = useState<GridValidRowModel[]>( [] );
  const [ hasNextPage, setHasNextPage ] = useState<boolean>( true );
  const [ endCursor, setEndCursor ] = useState<string | null>( null );
  const [ searchData, setSearchData ] = useState( "" );
  const [ employees, setEmployees ] = useState<EmpMasterEdge[]>( [] );

  const [ GetEmployees, { data, loading, fetchMore } ] = useLazyQuery<
    GetEmpResult,
    GetEmpVars
  >( GetEmp );

  const [ addEmpLdgrAssoic, { loading: addLoading } ] = useMutation<
    AddEmpLdgrAssoicResult,
    AddEmpLdgrAssoicVar
  >( AddEmpLdgrAssoic, {
    onError: ( err ) =>
    {
      setMessage( {
        flag: true,
        message: ( err as Error ).message,
        operation: Operation.NONE,
      } );
    },
  } );

  const handleCheckboxChange = ( id: number ) =>
  {
    setSelectedItems(
      ( prevSelected ) =>
        prevSelected.includes( id )
          ? prevSelected.filter( ( itemId ) => itemId !== id ) // Remove if already selected
          : [ ...prevSelected, id ] // Add if not selected
    );
  };

  const dynamicHeaders: TableHeaderProps[] = Users.List.map( ( header ) => ( {
    headerName: header.headerName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    hideable: header.hideable,
    cellClassName: header.cellClassName,
    renderCell: ( params ) =>
    {
      if ( header.field === "id" )
      {
        return (
          <>
            <Checkbox
              value={params.row}
              checked={selectedItems.includes( params.row.user_id )}
              onChange={() => handleCheckboxChange( params.row.user_id )}
              inputProps={{ "aria-label": "controlled" }}
            />
          </>
        );
      }

      return params.value;
    },
  } ) );
  const columns: GridColDef[] = [ ...dynamicHeaders ];

  const [ columnVisibilityModel, setColumnVisibilityModel ] =
    useState<GridColumnVisibilityModel>( {} );

  useEffect( () =>
  {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.ASSIGN_TO_SUPPLIER
    );
    if ( savedModel )
    {
      setColumnVisibilityModel( JSON.parse( savedModel ) );
    }
  }, [] );

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) =>
  {
    setColumnVisibilityModel( newModel );
    localStorage.setItem(
      ColumnVisibilityFor.ASSIGN_TO_SUPPLIER,
      JSON.stringify( newModel )
    );
  };

  const handleClear = () =>
  {
    setSelectedItems( [] );
  };

  const handleClose = () =>
  {
    setMessage( emptyMessage );
    setModalFlag( false );
  };

  const HandleSubmit = async () =>
  {
    try
    {

      if ( selectedItems.length )
      {
        if ( customer_id && selectedItems )
        {
          addEmpLdgrAssoic( {
            variables: {

              customer_id,
              user_details,
              ldgrID: selectedSupplier.supplierId,
              empIds: selectedItems,
            },
            refetchQueries: [
              {
                query: GetSuppliers,
                variables: {
                  after: null,
                  customer_id,
                  first: ROWS_PER_PAGE,
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: AtsAcLdgrOrderField.CREATED_AT,
                  },

                  name: searchData,
                  input: {
                    query_type: LdgrQueryType.ALL,
                    itemID: 0,
                  },
                },
              },
              {
                query: GetEmp,
                variables: {
                  customer_id,
                  after: null,
                  first: ROWS_PER_PAGE,
                  input: {
                    companyID: 0,
                    ldgrID: selectedSupplier.supplierId,
                    queryType: EmpQueryType.BY_TYPE,
                    siteID: 0,
                    subsidiaryID: 0,
                    empType: [ empType.TECHNICIAN ],
                  },
                  name: searchData,
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: EmpMasterOrderField.NAME,
                  },
                },
              },
              {
                query: GetEmp,
                variables: {
                  after: null,
                  customer_id: customer_id ? customer_id : 0,
                  first: ROWS_PER_PAGE,
                  input: {
                    queryType: EmpQueryType.NOT_ASSOICATED_VENDOR_USERS,
                    empType: [ empType.TECHNICIAN ],
                    companyID: 0,
                    ldgrID: 0,
                    siteID: 0,
                    subsidiaryID: 0,
                  },
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: EmpMasterOrderField.NAME,
                  },

                  name: searchData,
                },
              },
            ],
          } ).then( ( { data } ) =>
          {
            if ( data && data.AddEmpLdgrAssoic )
            {
              setMessage( {
                flag: true,
                message: "Added successfully",
                operation: Operation.CREATE,
              } );
              setSelectedItems( [] );
            }
          } );
        }
      } else
      {
        setMessage( {
          flag: true,
          message: `${ ledgerLabel } is missing`,
          operation: Operation.NONE,
        } );
      }
    } catch ( err )
    {
      setMessage( {
        flag: true,
        message: ( err as Error ).message,
        operation: Operation.NONE,
      } );
    }
  };

  useEffect( () =>
  {
    if ( data && !loading )
    {
      const newData = data.GetEmp.edges;

      if ( endCursor )
      {
        const updatedNewData = newData.map( ( newEmp ) =>
        {
          const filteredStudent = employees.find(
            ( employee ) => employee.node.id === newEmp.node.id
          );
          if ( filteredStudent )
          {
            return {
              ...newEmp,
              node: {
                ...newEmp.node,
              },
            };
          }
          return newEmp;
        } );
        setEmployees( updatedNewData );
        setRows(
          updatedNewData.map( ( { node }, index ) => ( {
            id: index + 1,
            name: node.name,
            mobile: node.mobile,
            email: node.email,
            user_type: "",
            user_id: node.id,
            customerName: node.customer.name,
          } ) )
        );
      } else
      {
        setEmployees( newData );
        setRows(
          newData.map( ( { node }, index ) => ( {
            id: index + 1,
            name: node.name,
            mobile: node.mobile,
            email: node.email,
            user_type: "",
            user_id: node.id,
            customerName: node.customer.name,
          } ) )
        );
      }
      setEndCursor( data.GetEmp.pageInfo.endCursor );
    } // eslint-disable-next-line
  }, [ data, loading ] );

  useEffect( () =>
  {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[ 0 ] as Element;
    const handleScroll = ( e: Event ) =>
    {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if ( scrollTop + clientHeight >= getModifiedScrollHeight( scrollHeight ) )
      {
        if ( hasNextPage && !loading )
        {
          fetchMore( {
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: ( prevResult, { fetchMoreResult } ) =>
            {
              if ( !fetchMoreResult ) return prevResult;

              const newEdges = fetchMoreResult.GetEmp.edges;
              const pageInfo = fetchMoreResult.GetEmp.pageInfo;
              setEndCursor( pageInfo.endCursor );
              setHasNextPage( pageInfo.hasNextPage );

              const duplicateCheck = prevResult.GetEmp.edges.filter(
                ( { node: { id } } ) =>
                  newEdges.findIndex(
                    ( { node: { id: newId } } ) => newId === id
                  ) !== -1
              );

              if ( duplicateCheck.length > 0 ) return prevResult;

              return {
                GetEmp: {
                  edges: [ ...employees, ...newEdges ],
                  pageInfo,
                  totalCount: data ? data.GetEmp.totalCount! : 0,
                },
              };
            },
          } );
        }
      }
    };
    if ( scrollTable && rows.length )
      scrollTable.addEventListener( "scroll", handleScroll );

    return () =>
    {
      if ( scrollTable ) scrollTable.removeEventListener( "scroll", handleScroll );
    };
  }, [ rows ] );

  useEffect( () =>
  {
    const fetchData = async () =>
    {
      try
      {

        if ( customer_id )
        {
          GetEmployees( {
            variables: {
              after: null,
              customer_id: customer_id ? customer_id : 0,
              first: ROWS_PER_PAGE,
              input: {
                queryType: EmpQueryType.NOT_ASSOICATED_VENDOR_USERS,
                empType: [],
                companyID: 0,
                ldgrID: 0,
                siteID: 0,
                subsidiaryID: 0,
              },
              orderBy: {
                direction: OrderDirection.ASC,
                field: EmpMasterOrderField.NAME,
              },

              name: searchData,   
            },
          } );
        }
      } catch ( err )
      {
        console.error( ( err as Error ).message );
      }
    };
    fetchData();
  }, [ customer_id, GetEmployees, searchData ] );

  const { ledgerLabel } = useLabels();
  return (
    <>
      <div className="assign-supplier">
        <div className="assign-supplier__title">
          <Title>Associate Employee to {ledgerLabel}</Title>
          <img src={Close} alt="" onClick={() => setModalFlag( false )} />
        </div>
        <div className="assign-supplier__header">
          <div className="assign-supplier__header--grid">
            <Label>{ledgerLabel} Name</Label>
            <span>:</span>
            <b>{selectedSupplier.supplierDesc}</b>
          </div>
        </div>
        <Title variant="subtitle1">Assign Employee</Title>

        <div className="associate-supplier__select row g-0">
          <div className="col-3">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={( e ) =>
              {
                setSearchData( e.target.value );
              }}
            />
          </div>
        </div>

        <div className="assign-supplier__tableblock--item">
          {rows.length ? (
            <StyledDatagrid
              columns={columns}
              rows={rows}
              rowHeight={TABLE_ROW_HEIGHT}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={handleColumnVisibilityChange}
              initialState={{
                columns: {
                  columnVisibilityModel: columnVisibilityModel,
                },
              }}
              onCellClick={( params ) =>
              {
                if ( params.field === "desc" )
                {
                  dispatch( {
                    type: payloadTypes.SET_SUPPLIER_ID,
                    payload: {
                      supplierId: params.row.supplier_id,
                    },
                  } );
                  setViewModal( !viewModal );
                }
              }}
              disableRowSelectionOnClick
              hideFooter
            />
          ) : (
            <>
              <img src={NoData} alt="" className="nodata-image" />
            </>
          )}
        </div>

        <div className="row g-0">
          <div className="col">
            <Button mode="save" onClick={HandleSubmit} />
            <Button mode="clear" onClick={handleClear} />
            <Button mode="cancel" onClick={() => setModalFlag( false )} />
          </div>
          <div className="col-4 flex-end">
            <div className="overall-total-count">
              Selected Employees <b>{selectedItems.length}</b>
            </div>
          </div>
        </div>
      </div>

      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal flag={!searchData && loading} />
    </>
  );
};

export default AssignEmps;
